(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pg-benefits-card"] && !Shopify.designMode) return;
  try {
    if(!window.__mlBenefits){window.__mlBenefits=true;
  const close=dialog=>{if(dialog?.open)dialog.close();};
  document.addEventListener('click',event=>{
    const open=event.target.closest?.('[data-benefits-open]');
    if(open){const dialog=document.querySelector('dialog[data-benefits-dialog]');if(!dialog)return;event.preventDefault();dialog.__opener=open;try{dialog.showModal();}catch{dialog.setAttribute('open','');}dialog.querySelector('[data-benefits-close]')?.focus({preventScroll:true});return;}
    const btn=event.target.closest?.('[data-benefits-close]');
    if(btn){close(btn.closest('dialog'));return;}
    const dialog=event.target.closest?.('dialog[data-benefits-dialog]');
    if(dialog&&event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close(dialog);}
  });
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const dialog=document.querySelector('dialog[data-benefits-dialog][open]');if(dialog&&!dialog.matches(':modal')){event.preventDefault();close(dialog);}});
  document.addEventListener('toggle',event=>{
    const dialog=event.target;if(!(dialog instanceof HTMLDialogElement)||!dialog.matches('[data-benefits-dialog]'))return;
    if(event.newState==='open'){document.documentElement.classList.add('pg-benefits-locked');}
    else{document.documentElement.classList.remove('pg-benefits-locked');const opener=dialog.__opener;dialog.__opener=null;opener?.focus?.({preventScroll:true});}
  },true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-brand-motion"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pg-brand-illustration'))customElements.define('pg-brand-illustration',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const{signal}=this.abort;this.reduced=matchMedia('(prefers-reduced-motion:reduce)');const update=()=>{this.dataset.playing=String(this.visible&&!document.hidden&&!this.reduced.matches);};this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;if(this.visible)this.dataset.active='';update();},{threshold:.3});this.observer.observe(this);document.addEventListener('visibilitychange',update,{signal});this.reduced.addEventListener('change',update,{signal});}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-installment-price"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pg-installment-price'))customElements.define('pg-installment-price',class extends HTMLElement{
 static get observedAttributes(){return ['amount','pix-percent','installments','total-first'];}
 connectedCallback(){this.render();}
 attributeChangedCallback(){if(this.isConnected)this.render();}
 render(){const cents=Number(this.getAttribute('amount'));if(!Number.isSafeInteger(cents)||cents<0)return;const lead=this.querySelector('[data-installment-lead]'),note=this.querySelector('[data-installment-note]'),total=this.querySelector('[data-price-total]');if(!lead||!note||!total)return;const money=n=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(n/100);let count=Number(this.getAttribute('installments'));const highlight=this.hasAttribute('installments')&&Number.isSafeInteger(count)&&count>0;if(!highlight)count=1;const base=Math.floor(cents/count);const totalFirst=this.hasAttribute('total-first');lead.textContent=highlight&&!totalFirst?(count+'x '+money(base)):money(cents);note.textContent=highlight?(totalFirst?'ou '+count+'x '+money(base)+' sem juros':'sem juros'):'';total.textContent=money(cents);const pix=this.querySelector('[data-installment-pix]'),percent=Number(this.getAttribute('pix-percent'));if(pix&&Number.isFinite(percent)&&percent>0&&percent<100)pix.textContent=money(Math.round(cents*(100-percent)/100));}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-interactions"] && !Shopify.designMode) return;
  try {
    function bindPetgrafRows(root = document) {
    root.querySelectorAll('.pg-row,.pg-category-tabs').forEach(row => {
      if (row.dataset.dragReady) return;
      row.dataset.dragReady = 'true';
      let startX = 0, startScroll = 0, active = false, dragged = false, velocity = 0, lastPointerX = 0, lastPointerTime = 0, coastFrame;
      if (row.dataset.autoplay === 'true' && !window.Shopify?.designMode && row.children.length > 1) {
        const originals = [...row.children];
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = reduced.matches, hovering = false, visible = false, cycle = 0, frame, last = 0, continuousOffset = null, lastStep = performance.now();
        const clone = node => { const copy = node.cloneNode(true); copy.dataset.loopClone = 'true'; copy.setAttribute('aria-hidden','true'); copy.removeAttribute('id'); copy.removeAttribute('data-shopify-editor-block'); copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id')); if(copy.matches('a,button,input')) copy.tabIndex = -1; copy.querySelectorAll('a,button,input,[tabindex]').forEach(el => el.tabIndex = -1); return copy; };
        row.prepend(...originals.map(clone)); row.append(...originals.map(clone));
        const measure = () => { const first = originals[0].getBoundingClientRect(), end = originals.at(-1).getBoundingClientRect(); const nextCycle = end.right - first.left + (parseFloat(getComputedStyle(row).columnGap) || 0); if(nextCycle > 0 && Math.abs(nextCycle - cycle) > 1) { cycle = nextCycle; row.scrollLeft = cycle; } };
        measure(); const resize = new ResizeObserver(measure); resize.observe(row);
        const visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; last = 0; }); visibility.observe(row);
        const pause = () => { paused = true; };
        row.addEventListener('pointerenter', () => { hovering = true; });
        row.addEventListener('pointerleave', () => { hovering = false; });
        row.addEventListener('pointerdown', pause); row.addEventListener('focusin', pause); row.addEventListener('wheel', pause, {passive:true});
        reduced.addEventListener('change', pause);
        const normalize = () => {
          if (!cycle || active) return;
          if (row.scrollLeft < cycle * .5) row.scrollLeft += cycle;
          else if (row.scrollLeft > cycle * 1.5) row.scrollLeft -= cycle;
        };
        row.addEventListener('scrollend', normalize);
        function tick(now) {
          if(!row.isConnected) { resize.disconnect(); visibility.disconnect(); reduced.removeEventListener('change',pause); cancelAnimationFrame(frame); return; }
          const delta = last ? Math.min(now - last,50) : 0; last = now;
          if(visible && !document.hidden && !paused && !hovering && !active && !reduced.matches && !document.querySelector('dialog[open]')) {
            if(row.dataset.motion === 'continuous') { if(continuousOffset === null) continuousOffset = row.scrollLeft; continuousOffset += delta * .025; row.scrollLeft = continuousOffset; if(cycle && (row.scrollLeft < cycle * .5 || row.scrollLeft > cycle * 1.5)) { normalize(); continuousOffset = row.scrollLeft; } }
            else if(now - lastStep > Number(row.dataset.interval || 3200)) {
              normalize(); const step = originals[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
              row.scrollBy({left:step * Number(row.dataset.direction || 1),behavior:'smooth'}); lastStep = now;
            }
          } else { lastStep = now; continuousOffset = null; }
          frame = requestAnimationFrame(tick);
        }
        frame = requestAnimationFrame(tick);
      }
      row.addEventListener('dragstart', event => event.preventDefault());
      row.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        cancelAnimationFrame(coastFrame); velocity = 0; lastPointerX = event.clientX; lastPointerTime = performance.now();
        active = true; dragged = false; startX = event.clientX; startScroll = row.scrollLeft;
      });
      row.addEventListener('pointermove', event => {
        if (!active) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 6) return;
        dragged = true; row.classList.add('is-dragging');
        const now = performance.now(); velocity = (lastPointerX - event.clientX) / Math.max(now - lastPointerTime, 1); lastPointerX = event.clientX; lastPointerTime = now;
        if (!row.hasPointerCapture(event.pointerId)) row.setPointerCapture(event.pointerId);
        row.scrollLeft = startScroll - distance;
        event.preventDefault();
      });
      const finish = event => { if(!active)return; active = false; row.classList.remove('is-dragging'); if(event.type !== 'pointerup' || !dragged || !row.matches('.pg-row') || performance.now()-lastPointerTime > 100 || matchMedia('(prefers-reduced-motion: reduce)').matches)return;let last=performance.now();function coast(now){const delta=Math.min(now-last,32);last=now;velocity*=Math.pow(.92,delta/16);row.scrollLeft+=velocity*delta;if(Math.abs(velocity)>.02&&row.isConnected&&!active)coastFrame=requestAnimationFrame(coast);}coastFrame=requestAnimationFrame(coast); };
      row.addEventListener('pointerup', finish);
      row.addEventListener('pointercancel', finish);
      row.addEventListener('lostpointercapture', finish);
      row.addEventListener('pointerleave', () => { if (!dragged) active = false; });
      row.addEventListener('click', event => { if (dragged && event.detail !== 0) { event.preventDefault(); event.stopPropagation(); } dragged = false; }, true);
    });
  }
  bindPetgrafRows();
  document.addEventListener('shopify:section:load', event => bindPetgrafRows(event.target));
  document.addEventListener('click', event => {
    if(event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const link = event.target.closest('.pg-bottom a,.pg-logo,.pg-category-tabs a');
    if(!link) return;
    const url = new URL(link.href,location.origin);
    if(url.origin !== location.origin || url.pathname !== location.pathname || url.search) return;
    if(url.hash && url.hash !== '#catalogo-section') return;
    const target = url.hash ? document.getElementById('catalogo-section') : null;
    if(url.hash && !target) return;
    event.preventDefault();
    const top = target ? window.scrollY + target.getBoundingClientRect().top - 88 : 0;
    window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-legacy-swap"] && !Shopify.designMode) return;
  try {
    if(!window.pgLegacySwapReady){window.pgLegacySwapReady=true;
document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-legacy-swap]');if(!button||button.disabled)return;
  event.preventDefault();
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const cart=window.petgrafCart;
  const post=(path,body)=>fetch(root+path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(response=>{if(!response.ok)throw new Error(path);return response.json();});
  const swap=async()=>{
    let properties={};try{properties=JSON.parse(button.dataset.properties||'{}')||{};}catch{}
    if(button.dataset.reference&&!properties['Referência de arte'])properties['Referência de arte']=button.dataset.reference;
    await post('cart/add.js',{items:[{id:Number(button.dataset.variant),quantity:Number(button.dataset.quantity)||1,properties}]});
    await post('cart/change.js',{id:button.dataset.lineKey,quantity:0});
  };
  button.disabled=true;button.setAttribute('aria-busy','true');
  try{
    if(cart&&cart.exclusive)await cart.exclusive(swap);else await swap();
    if(cart&&cart.refresh){await cart.refresh();cart.notify&&cart.notify('Material trocado pela versão atual.');}else location.reload();
  }catch{
    button.disabled=false;button.removeAttribute('aria-busy');
    if(cart&&cart.refresh){try{await cart.refresh();}catch{}}
    cart&&cart.notify?cart.notify('Não conseguimos trocar agora. Confira o carrinho e tente de novo.'):location.reload();
  }
});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-logo-specialty-filter"] && !Shopify.designMode) return;
  try {
    if(!window.__pgLogoFilter){window.__pgLogoFilter=true;
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-logo-filter-toggle]');
    if(toggle){const box=toggle.closest('[data-logo-filter]');const open=!box.classList.contains('is-open');box.classList.toggle('is-open',open);toggle.setAttribute('aria-expanded',String(open));return;}
    const chip=event.target.closest('[data-logo-filter-value]');if(!chip)return;
    const nav=chip.closest('[data-logo-filter]');const grid=nav&&document.querySelector(nav.dataset.logoFilter);if(!grid)return;
    const value=chip.dataset.logoFilterValue;let shown=0;
    nav.querySelectorAll('[data-logo-filter-value]').forEach(button=>button.setAttribute('aria-pressed',String(button===chip)));
    grid.querySelectorAll('[data-specialties]').forEach(card=>{const list=' '+card.dataset.specialties+' ';const match=!value||list.includes(' * ')||list.includes(' '+value+' ');card.classList.toggle('is-esp-hidden',!match);if(match)shown++;});
    const empty=nav.querySelector('[data-logo-filter-empty]');if(empty)empty.hidden=shown>0||!value;
    const button=nav.querySelector('[data-logo-filter-toggle]');
    if(button){const current=button.querySelector('[data-logo-filter-current]');current.textContent=value?chip.textContent:button.dataset.defaultLabel;button.classList.toggle('is-filtered',!!value);
      if(matchMedia('(max-width:767px)').matches){nav.classList.remove('is-open');button.setAttribute('aria-expanded','false');}}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-logo-terms"] && !Shopify.designMode) return;
  try {
    if(!window.__pgLogoTerms){window.__pgLogoTerms=true;
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-logo-terms-open]');
    if(open){event.preventDefault();const dialog=document.querySelector('dialog[data-logo-terms]');if(!dialog)return;dialog.dataset.returnFocus='';dialog.__opener=open;try{dialog.showModal();}catch{dialog.setAttribute('open','');}dialog.querySelector('[data-logo-terms-close]')?.focus({preventScroll:true});return;}
    const close=event.target.closest('[data-logo-terms-close]');
    if(close){const dialog=close.closest('dialog');dialog.close();dialog.__opener?.focus?.({preventScroll:true});return;}
    const dialog=event.target.closest?.('dialog[data-logo-terms]');
    if(dialog&&event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const footer=document.querySelector('#site-footer'),root=document.documentElement;
  if(footer){const observer=new IntersectionObserver(([entry])=>root.classList.toggle('pg-footer-in-view',entry.isIntersecting),{rootMargin:'0px 0px -68px 0px',threshold:0});observer.observe(footer);}
  const navs=[...document.querySelectorAll('.pg-mobile-nav')],purchase=document.querySelector('pg-mobile-purchase');
  const sync=()=>{const active=navs.find(n=>getComputedStyle(n).position==='fixed'&&n.getBoundingClientRect().height);const values={'--pg-mobile-nav-height':active?Math.ceil(active.getBoundingClientRect().height):68,'--pg-purchase-bar-height':purchase?Math.ceil(purchase.getBoundingClientRect().height):0};for(const [name,value] of Object.entries(values)){const px=value+'px';if(root.style.getPropertyValue(name)!==px)root.style.setProperty(name,px);}};
  // Primeira leitura no quadro seguinte: ler medidas durante a execução do script forçava layout (forced reflow).
  const sizes=new ResizeObserver(sync);navs.forEach(n=>sizes.observe(n));if(purchase)sizes.observe(purchase);requestAnimationFrame(sync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-mobile-purchase')) customElements.define('pg-mobile-purchase', class extends HTMLElement {
  connectedCallback() {
    const form = document.querySelector('.pg-product-page form[action*="/cart/add"]');
    const add = form?.querySelector('.pg-add');
    if (!form || !add) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    const buy = this.querySelector('button');
    const canPurchase = () => !form.classList.contains('pg-quote-only') && Number(form.querySelector('pg-installment-price')?.getAttribute('amount') ?? this.dataset.initialPrice) > 0;
    const syncVisibility = () => {
      this.frame = null;
      this.hidden = !canPurchase() || innerWidth > 767 || add.getBoundingClientRect().bottom > 0;
    };
    // A fast scroll can skip every intersection threshold between below and above.
    const scheduleVisibility = () => {
      if (this.frame == null) this.frame = requestAnimationFrame(syncVisibility);
    };
    this.observer = new IntersectionObserver(scheduleVisibility, { threshold: [0, 1] });
    this.observer.observe(add);
    window.addEventListener('scroll', scheduleVisibility, { passive: true, signal });
    window.addEventListener('resize', scheduleVisibility, { passive: true, signal });
    window.addEventListener('pageshow', scheduleVisibility, { signal });
    buy.addEventListener('click', () => { if (canPurchase() && !add.disabled) form.requestSubmit(add); }, { signal });
    const update = () => {
      const price = form.querySelector('pg-installment-price');
      if(price) this.querySelector('[data-sticky-price]').textContent = new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(Number(price.getAttribute('amount'))/100);
      // Reuse the selected run; the monetary total follows the live variant price.
      const label = form.querySelector('[name="id"]:checked')?.closest('label');
      const run = label?.querySelector('b .pg-unit-short')?.textContent?.trim();
      const summary = this.querySelector('[data-sticky-run]');
      if (run && summary) summary.textContent = run;
      buy.disabled = !canPurchase() || add.disabled;
      if (!canPurchase()) this.hidden = true;
      const actionLabel=add.querySelector('[data-add-label]')?.textContent?.trim()||add.dataset.availableLabel;
      if(actionLabel){this.querySelector('[data-sticky-label]').textContent=actionLabel;buy.setAttribute('aria-label',actionLabel);}
    };
    form.addEventListener('change', () => requestAnimationFrame(update), { signal });
    this.mutation = new MutationObserver(update);
    this.mutation.observe(add, { attributes: true, attributeFilter: ['disabled'], childList:true, characterData:true, subtree:true });
    update();
    scheduleVisibility();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.mutation?.disconnect();
    cancelAnimationFrame(this.frame);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-nav-state"] && !Shopify.designMode) return;
  try {
    (() => {
    const nav = document.querySelector('.pg-bottom');
    if (!nav) return;
    const links = [...nav.querySelectorAll('a')];
    let catalogVisible = location.hash === '#catalogo-section';
    function sync() {
      const cart = document.querySelector('[data-cart-dialog][open]');
      const search = document.querySelector('[data-search-dialog][open]');
      const process = document.querySelector('#pg-process-sheet[open]');
      const collectionsOpen = document.querySelector('#pg-collections-sheet[open]');
      const path = location.pathname;
      const destination = name => new URL(links.find(link => link.dataset.nav === name).href).pathname;
      const active = process ? 'process' : collectionsOpen ? 'collections' : cart ? 'cart' : search ? 'search' : path === destination('cart') ? 'cart' : path === destination('search') ? 'search' : path.includes('/collections/') || path.includes('/products/') || catalogVisible ? 'collections' : path === destination('home') ? 'home' : '';
      links.forEach(link => { if (link.dataset.nav === active) link.setAttribute('aria-current', process || collectionsOpen || cart || search ? 'true' : 'page'); else link.removeAttribute('aria-current'); });
    }
    const observer = new MutationObserver(sync);
    document.querySelectorAll('[data-cart-dialog],[data-search-dialog],#pg-process-sheet,#pg-collections-sheet').forEach(dialog => observer.observe(dialog, {attributes:true,attributeFilter:['open']}));
    const catalog = document.getElementById('catalogo-section');
    if (catalog) {
      const update = () => { catalogVisible = catalog.getBoundingClientRect().top < innerHeight * .45; sync(); };
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      update();
    }
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-pilot-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.querySelector('[data-pilot-process]');
  if(!root)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),steps=[...root.querySelectorAll('[data-pilot-step]')];
  let animations=[];
  const stop=()=>{animations.forEach(animation=>animation.cancel());animations=[];};
  const play=()=>{
    stop();
    if(reduced.matches)return;
    steps.forEach((step,index)=>{
      const number=step.querySelector('.pg-pilot-number');
      animations.push(number.animate([{transform:'scale(1)',opacity:1},{transform:'scale(1.14)',opacity:1},{transform:'scale(1)',opacity:1}],{duration:600,delay:index*700,easing:'cubic-bezier(.23,1,.32,1)'}));
    });
  };
  reduced.addEventListener('change',stop);
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){play();observer.disconnect();}},{threshold:.5});observer.observe(root.querySelector('.pg-pilot-steps'));}
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-process-sheet"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pg-process-sheet').forEach(sheet => {
  const triggers=[...document.querySelectorAll(`[aria-controls="${sheet.id}"]`)],grip=sheet.querySelector('[data-process-grip]');
  let opener,animation,closing=false,start=null,offset=0;
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion=(frames,duration)=>{animation?.cancel();animation=sheet.animate(frames,{duration:reduced()?0:duration,easing:'cubic-bezier(.16,1,.3,1)'});return animation.finished.catch(()=>{});};
  const close=async()=>{if(!sheet.open||closing)return;closing=true;await motion([{transform:`translateY(${offset}px)`},{transform:'translateY(100%)'}],180);sheet.close();};
  triggers.forEach(trigger=>trigger.addEventListener('click',event=>{if(typeof sheet.showModal!=='function')return;event.preventDefault();if(sheet.open)return;document.querySelectorAll('dialog[open]').forEach(other=>other.close());opener=trigger;closing=false;offset=0;sheet.style.transform='';sheet.showModal();sheet.querySelector('.pg-process-body').scrollTop=0;trigger.setAttribute('aria-expanded','true');motion([{transform:'translateY(100%)'},{transform:'translateY(0)'}],280);}));
  sheet.querySelectorAll('[data-process-close]').forEach(button=>button.addEventListener('click',close));
  sheet.addEventListener('cancel',event=>{event.preventDefault();close();});
  sheet.addEventListener('click',event=>{if(event.target!==sheet)return;const box=sheet.getBoundingClientRect();if(event.clientY<box.top||event.clientX<box.left||event.clientX>box.right)close();});
  sheet.addEventListener('close',()=>{animation?.cancel();sheet.style.transform='';offset=0;start=null;closing=false;triggers.forEach(t=>t.setAttribute('aria-expanded','false'));opener?.focus({preventScroll:true});});
  grip.addEventListener('pointerdown',event=>{if(closing||!event.isPrimary||event.button!==0)return;animation?.cancel();start=event.clientY;offset=0;grip.setPointerCapture(event.pointerId);});
  grip.addEventListener('pointermove',event=>{if(start===null)return;offset=Math.max(0,event.clientY-start);sheet.style.transform=`translateY(${offset}px)`;});
  const settle=()=>{if(start===null)return;start=null;if(offset>80){close();}else{const from=offset;offset=0;sheet.style.transform='';motion([{transform:`translateY(${from}px)`},{transform:'translateY(0)'}],180);}};
  grip.addEventListener('pointerup',settle);
  grip.addEventListener('pointercancel',()=>{start=null;offset=0;sheet.style.transform='';});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-process-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-process-story')) customElements.define('pg-process-story', class extends HTMLElement {
 connectedCallback() {
  this.abort = new AbortController();
  const { signal } = this.abort;
  this.track = this.querySelector('ol');
  this.scenes = [...this.querySelectorAll('[data-scene]')];
  this.dots = [...this.querySelectorAll('[data-step]')];
  this.mobile = matchMedia('(max-width:767px)');
  this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
  this.index = 0;
  this.visible = false;
  this.userPaused = false;
  this.holding = false;
  this.clones = [this.scenes.at(-1), this.scenes[0]].map(scene => {
    const clone = scene.cloneNode(true);
    clone.dataset.clone = 'true';
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    clone.removeAttribute('aria-current');
    return clone;
  });
  this.track.prepend(this.clones[0]);
  this.track.append(this.clones[1]);
  this.physical = [...this.track.children];
  this.dataset.enhanced = 'true';
  this.querySelector('.pg-story-controls').hidden = false;
  this.track.addEventListener('pointerdown', e => {
    if (e.isPrimary === false || (e.pointerType === 'mouse' && e.button !== 0)) return;
    this.holding = true; this.userPaused = false; this.reconcile();
    if (!this.mobile.matches || e.pointerType === 'mouse') this.drag = { id:e.pointerId, x:e.clientX, y:e.clientY, delta:0, left:this.track.scrollLeft, moved:false };
  }, { signal });
  window.addEventListener('pointermove', e => {
    if (!this.drag || e.pointerId !== this.drag.id) return;
    this.drag.delta = e.clientX - this.drag.x;
    if (Math.abs(this.drag.delta) > 5 && Math.abs(this.drag.delta) > Math.abs(e.clientY - this.drag.y)) { this.drag.moved = true; this.track.dataset.dragging = 'true'; this.track.setPointerCapture(e.pointerId); }
    if (this.drag.moved) {
      e.preventDefault();
      if (this.mobile.matches) this.track.scrollLeft = this.drag.left - this.drag.delta;
    }
  }, { signal });
  const release = e => {
    if (!this.holding || (this.drag && e.pointerId !== this.drag.id)) return;
    const advance = !this.mobile.matches && e.type !== 'pointercancel' && this.drag?.moved && Math.abs(this.drag.delta) >= 40;
    const direction = this.drag?.delta < 0 ? 1 : -1;
    this.holding = false; this.drag = null; delete this.track.dataset.dragging;
    if (this.track.hasPointerCapture(e.pointerId)) this.track.releasePointerCapture(e.pointerId);
    if (advance) this.go(this.index + direction); else this.settle();
  };
  window.addEventListener('pointerup', release, { signal });
  window.addEventListener('pointercancel', release, { signal });
  this.track.addEventListener('dragstart', e => e.preventDefault(), { signal });
  this.track.addEventListener('scroll', () => {
    if (!this.mobile.matches) return;
    clearTimeout(this.timer); clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(() => this.settle(), 140);
  }, { passive:true, signal });
  this.addEventListener('keydown', e => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault(); this.userPaused = true; this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
  }, { signal });
  this.track.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover) and (pointer:fine)').matches) { this.hovered = true; this.reconcile(); } }, { signal });
  this.track.addEventListener('mouseleave', () => { this.hovered = false; this.reconcile(); }, { signal });
  this.addEventListener('focusin', () => { this.userPaused = this.track.matches(':focus-visible'); this.reconcile(); }, { signal });
  this.addEventListener('focusout', () => { this.userPaused = false; this.reconcile(); }, { signal });
  document.addEventListener('visibilitychange', () => this.reconcile(), { signal });
  this.reduced.addEventListener('change', () => this.reconcile(), { signal });
  this.mobile.addEventListener('change', () => { this.update(); requestAnimationFrame(() => this.jump(this.index + 1)); this.reconcile(); }, { signal });
  this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.reconcile(); }, { threshold:.25 });
  this.observer.observe(this);
  this.update();
  requestAnimationFrame(() => this.jump(1));
 }
 position(n) { return this.physical[n].offsetLeft - this.track.offsetLeft - 16; }
 jump(n) { if (this.mobile.matches) this.track.scrollTo({ left:this.position(n), behavior:'auto' }); }
 update() {
  this.scenes.forEach((scene,i) => {
    scene.toggleAttribute('data-active', i === this.index);
    if (i === this.index) scene.setAttribute('aria-current','step'); else scene.removeAttribute('aria-current');
    if (this.mobile.matches || i === this.index) scene.removeAttribute('aria-hidden'); else scene.setAttribute('aria-hidden','true');
  });
  this.dots.forEach((dot,i) => i === this.index ? dot.setAttribute('aria-current','step') : dot.removeAttribute('aria-current'));
  this.track.setAttribute('aria-label', `Etapas do pedido. Etapa ${this.index + 1} de ${this.scenes.length}`);
 }
 go(next) {
  clearTimeout(this.timer);
  const wrapped = (next + this.scenes.length) % this.scenes.length;
  if (this.mobile.matches) {
    const physical = next < 0 ? 0 : next >= this.scenes.length ? this.physical.length - 1 : next + 1;
    this.track.scrollTo({ left:this.position(physical), behavior:this.reduced.matches ? 'auto' : 'smooth' });
  }
  this.index = wrapped;
  this.update(); this.reconcile();
 }
 settle() {
  if (!this.mobile.matches || this.holding) { this.reconcile(); return; }
  const physical = this.physical.reduce((best,_,i) => Math.abs(this.position(i)-this.track.scrollLeft) < Math.abs(this.position(best)-this.track.scrollLeft) ? i : best, 0);
  this.index = (physical - 1 + this.scenes.length) % this.scenes.length;
  if (physical === 0 || physical === this.physical.length - 1) this.jump(this.index + 1);
  this.update(); this.reconcile();
 }
 reconcile() {
  clearTimeout(this.timer);
  const running = this.visible && !document.hidden && !this.reduced.matches && !this.userPaused && !this.holding && !this.hovered;
  this.running = running;
  this.dataset.playing = String(running);
  if (running) this.timer = setTimeout(() => this.go(this.index + 1), 3800);

 }
 disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); clearTimeout(this.settleTimer); this.animation?.cancel(); this.clones?.forEach(c => c.remove()); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-product-behavior"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pg-product-action'))customElements.define('pg-product-action',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort;
      const sync=()=>{const button=this.querySelector('.pg-add'),label=button?.querySelector('[data-add-label]');if(!button||!label)return;const text=window.petgrafDesign?.valid()?this.dataset.savedLabel:this.dataset.personalizeLabel;button.dataset.availableLabel=text;const form=this.closest('form'),selected=form?.querySelector('select[name=id]')?.selectedOptions[0]||form?.querySelector('[name=id]:checked');const unavailable=selected?(selected.dataset.available===undefined?selected.disabled:selected.dataset.available==='false'):button.disabled;const next=unavailable?button.dataset.unavailableLabel:text;if(!button.classList.contains('is-added')&&label.textContent!==next)label.textContent=next;};
      document.addEventListener('pg:design-state',sync,{signal});document.addEventListener('pg:design-saved',sync,{signal});sync();
    }
    disconnectedCallback(){this.abort?.abort();}
  });
  (() => {
    const gestures = new WeakMap(), suppressed = new WeakMap();
    const mobile=matchMedia('(max-width:767px)');
    function setZoom(figure,on,instant=false){
      const image=figure.querySelector('img'),button=figure.querySelector('[data-inline-zoom]');if(!image||!button)return;
      image.style.transitionDuration=instant?'0ms':'';
      if(!image.dataset.originalSizes)image.dataset.originalSizes=image.sizes;
      image.sizes=on?`${Math.ceil(figure.clientWidth*1.8)}px`:image.dataset.originalSizes;
      figure.toggleAttribute('data-zoomed',on);button.setAttribute('aria-pressed',String(on));button.setAttribute('aria-label',on?button.dataset.zoomOut:button.dataset.zoomIn);
    }
    document.addEventListener('click',event=>{
      const gallery=event.target.closest('[data-gallery]');
      if(gallery&&event.detail!==0&&performance.now()<(suppressed.get(gallery)||0)){event.preventDefault();event.stopImmediatePropagation();return;}
      const button=event.target.closest('[data-inline-zoom]');if(!button||!mobile.matches)return;
      event.preventDefault();const figure=button.closest('.pg-gallery-photo'),on=!figure.hasAttribute('data-zoomed');
      if(on){const rect=figure.getBoundingClientRect();figure.querySelector('img').style.transformOrigin=event.detail===0?'50% 50%':`${Math.max(0,Math.min(100,(event.clientX-rect.left)/rect.width*100))}% ${Math.max(0,Math.min(100,(event.clientY-rect.top)/rect.height*100))}%`;}
      setZoom(figure,on,event.detail===0);
    },true);
    document.addEventListener('scroll',event=>{if(event.target.matches?.('[data-gallery]'))event.target.querySelectorAll('[data-zoomed]').forEach(figure=>setZoom(figure,false,true));},true);
    mobile.addEventListener('change',()=>document.querySelectorAll('[data-zoomed]').forEach(figure=>setZoom(figure,false,true)));
    const isCarousel = gallery => matchMedia('(max-width:767px)').matches && gallery.scrollWidth > gallery.clientWidth + 1;
    document.addEventListener('dragstart',event=>{if(event.target.closest('[data-gallery]'))event.preventDefault();});
    document.addEventListener('pointerdown',event=>{
      const gallery=event.target.closest('[data-gallery]');
      if(!gallery || !isCarousel(gallery) || event.pointerType==='touch' || event.button!==0)return;
      gestures.set(gallery,{id:event.pointerId,x:event.clientX,y:event.clientY,left:gallery.scrollLeft,dragged:false});
    });
    document.addEventListener('pointermove',event=>{
      const gallery=event.target.closest('[data-gallery]'),s=gallery && gestures.get(gallery);
      if(!s || event.pointerId!==s.id)return;
      const dx=event.clientX-s.x,dy=event.clientY-s.y;
      if(!s.dragged && Math.abs(dy)>Math.abs(dx) && Math.abs(dy)>6){gestures.delete(gallery);return;}
      if(!s.dragged && Math.abs(dx)<6)return;
      s.dragged=true;gallery.classList.add('is-dragging');
      if(!gallery.hasPointerCapture(event.pointerId))gallery.setPointerCapture(event.pointerId);
      event.preventDefault();gallery.scrollLeft=s.left-dx;
    });
    function finish(event){
      const gallery=event.target.closest('[data-gallery]'),s=gallery && gestures.get(gallery);
      if(!s)return;
      if(s.dragged)suppressed.set(gallery,performance.now()+400);
      gestures.delete(gallery);gallery.classList.remove('is-dragging');
      if(gallery.hasPointerCapture(s.id))gallery.releasePointerCapture(s.id);
    }
    document.addEventListener('pointerup',finish);
    document.addEventListener('pointercancel',finish);
    document.addEventListener('lostpointercapture',finish);
    document.addEventListener('pointerout',event=>{
      const gallery=event.target.closest('[data-gallery]'),s=gallery && gestures.get(gallery);
      if(s && !s.dragged && !gallery.contains(event.relatedTarget))gestures.delete(gallery);
    });
    document.addEventListener('keydown',event=>{
      const gallery=event.target.closest('[data-gallery]');
      if(!gallery || !isCarousel(gallery) || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();event.stopPropagation();
      const slides=[...gallery.querySelectorAll('.pg-gallery-photo')],origin=gallery.getBoundingClientRect().left;
      const positions=slides.map(slide=>slide.getBoundingClientRect().left-origin+gallery.scrollLeft);
      let index=positions.reduce((best,left,i)=>Math.abs(left-gallery.scrollLeft)<Math.abs(positions[best]-gallery.scrollLeft)?i:best,0);
      if(event.key==='Home')index=0;else if(event.key==='End')index=slides.length-1;else index=Math.max(0,Math.min(slides.length-1,index+(event.key==='ArrowRight'?1:-1)));
      gallery.scrollTo({left:positions[index],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
    const box=document.querySelector('[data-lightbox]');let links=[],index=0;
    function imageAt(next){index=(next+links.length)%links.length;const image=box.querySelector('[data-lightbox-photo]');image.src=links[index].href;image.alt=links[index].closest('.pg-gallery-photo')?.querySelector('img')?.alt || '';box.querySelector('[data-lightbox-count]').textContent=`${index+1} / ${links.length}`;box.querySelectorAll('[data-lightbox-prev],[data-lightbox-next]').forEach(button=>button.hidden=links.length<2);}
    document.addEventListener('click',event=>{const link=event.target.closest('[data-lightbox-image]');if(!link || !box || matchMedia('(max-width:767px)').matches || event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();links=[...link.closest('[data-gallery]').querySelectorAll('[data-lightbox-image]')];imageAt(links.indexOf(link));document.dispatchEvent(new CustomEvent('pg:open-dialog',{detail:{dialog:box,opener:link}}));});
    box?.querySelector('[data-lightbox-prev]').addEventListener('click',()=>imageAt(index-1));box?.querySelector('[data-lightbox-next]').addEventListener('click',()=>imageAt(index+1));
    box?.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();imageAt(index+(event.key==='ArrowLeft'?-1:1));}});
    document.querySelectorAll('[data-specs-dialog],[data-cart-dialog]').forEach(dialog=>{
      let start=null;
      dialog.addEventListener('pointerdown',event=>{if(event.target.closest('[data-sheet-handle],.pg-dialog-toolbar') && !event.target.closest('button') && matchMedia('(max-width:1023px)').matches){start={x:event.clientX,y:event.clientY,time:performance.now()};dialog.setPointerCapture(event.pointerId);}});
      dialog.addEventListener('pointerup',event=>{if(!start)return;const y=event.clientY-start.y,velocity=y/(performance.now()-start.time)*1000;if(y>140||y>30&&velocity>850)dialog.close();start=null;});
      dialog.addEventListener('pointercancel',()=>{start=null;});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-quantity-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-quantity-options')) customElements.define('pg-quantity-options',class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const button=this.querySelector('.pg-quantity-more');
      if(button){
        this.dataset.compact='true';button.hidden=false;
        if(this.id==='quantidades'&&location.hash==='#quantidades'){delete this.dataset.compact;button.hidden=true;button.setAttribute('aria-expanded','true');}
        button.addEventListener('click',()=>{delete this.dataset.compact;button.setAttribute('aria-expanded','true');this.querySelector('label:not([data-mobile-primary]) input:not(:disabled)')?.focus({preventScroll:true});button.hidden=true;});
      }
      const formatPicker=this.querySelector('[data-at-format-picker]');
      if(formatPicker){
        const root=this.closest('[data-pg-product]')||this.closest('[data-quote-product]')||this,labels=[...this.querySelectorAll('label[data-at-variant-format]')],spec=this.querySelector('[data-at-format-spec]'),specs={Duo:'15 × 20 cm aberta · 10 × 15 cm fechada · uma dobra',Trio:'30 × 20 cm aberta · 10 × 20 cm fechada · dois vincos',A4:'21 × 29,7 cm · sem dobra',A5:'14,8 × 21 cm · sem dobra'};
        const setFormat=(format,change)=>{const current=this.querySelector('input[name=id]:checked'),quantity=current?.dataset.atQuantity,visible=labels.filter(l=>l.dataset.atVariantFormat===format);labels.forEach(l=>{l.hidden=l.dataset.atVariantFormat!==format;l.removeAttribute('data-mobile-primary')});visible.forEach((l,i)=>{if([0,Math.floor((visible.length-1)/3),Math.floor(2*(visible.length-1)/3),visible.length-1].includes(i))l.setAttribute('data-mobile-primary','')});formatPicker.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.atFormat===format)));if(spec)spec.textContent=specs[format]||format;root.querySelectorAll('[data-at-sheet-size]').forEach(n=>n.textContent=specs[format]||format);root.querySelectorAll('[data-at-sheet-finish]').forEach(n=>n.textContent=format==='Duo'?'Um vinco central':format==='Trio'?'Dois vincos':'Blocado');root.querySelectorAll('[data-at-sheet-pages]').forEach(n=>{if(format==='Duo')n.textContent='4 faces · uma dobra';if(format==='Trio')n.textContent='6 faces · dois vincos'});if(change){const next=visible.map(l=>l.querySelector('input')).find(i=>!i.disabled&&i.dataset.atQuantity===quantity)||visible.map(l=>l.querySelector('input')).find(i=>!i.disabled);if(next){next.checked=true;next.dispatchEvent(new Event('change',{bubbles:true}));const u=new URL(location.href);u.searchParams.set('variant',next.value);history.replaceState(null,'',u)}}};
        formatPicker.addEventListener('click',e=>{const b=e.target.closest('[data-at-format]');if(b)setFormat(b.dataset.atFormat,true)});const initial=this.querySelector('input[name=id]:checked')?.closest('label').dataset.atVariantFormat;if(initial)setFormat(initial,false);
      }
      const suggestion=this.querySelector('.pg-quantity-suggestion');
      if(!this.hasAttribute('data-quantity-upsell')||this.dataset.currency!=='BRL')return;
      const money=cents=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100);
      let target;
      const update=()=>{
        const options=[...this.querySelectorAll('input[name=id]')].map(input=>({input,...this.constructor.run(input.dataset.runTitle),price:Number(input.dataset.priceCents)}));
        const selected=options.find(option=>option.input.checked);
        target=this.constructor.offer(options,selected);suggestion.hidden=!target;
        if(!target)return;
        const saving=this.constructor.saving(selected,target);suggestion.querySelector('p').textContent='Mais '+(target.count-selected.count)+' '+(target.count-selected.count===1?target.unit:target.plural)+' por '+money(target.price-selected.price)+'.'+(saving>=5?' Cada '+target.unit+' sai '+saving+'% mais '+(/^(carteira|folha|unidade|lâmina)$/.test(target.unit)?'barata':'barato')+'.':'');
        suggestion.querySelector('button').textContent='Escolher '+target.count+' '+target.plural;
      };
      suggestion.querySelector('button').addEventListener('click',()=>{if(target){const chosen=target.input;chosen.click();chosen.focus({preventScroll:true});}});
      this.addEventListener('change',update);update();
    }
    static run(title){
      const match=String(title).match(/^(\d[\d.]*) (unidade|unidades|bloco|blocos|folha|folhas|talão|talões|ímã|ímãs|carteira|carteiras|cartão|cartões|lâmina|lâminas)$/i);if(!match)return {};
      const words={unidade:['unidade','unidades'],unidades:['unidade','unidades'],bloco:['bloco','blocos'],blocos:['bloco','blocos'],folha:['folha','folhas'],folhas:['folha','folhas'],talão:['talão','talões'],talões:['talão','talões'],ímã:['ímã','ímãs'],ímãs:['ímã','ímãs'],carteira:['carteira','carteiras'],carteiras:['carteira','carteiras'],cartão:['cartão','cartões'],cartões:['cartão','cartões'],lâmina:['lâmina','lâminas'],lâminas:['lâmina','lâminas']};
      const [unit,plural]=words[match[2].toLowerCase()];return {count:Number(match[1].replaceAll('.','')),unit,plural};
    }
    static saving(selected,target){
      const base=selected.price*target.count,next=target.price*selected.count;
      return base>0?Math.floor((base-next)*100/base):0;
    }
    static offer(options,selected){
      if(!selected?.count||!Number.isSafeInteger(selected.price)||selected.price<=0)return null;
      return options.filter(option=>!option.input.disabled&&option.unit===selected.unit&&Number.isSafeInteger(option.count)&&option.count>selected.count&&Number.isSafeInteger(option.price)&&option.price>selected.price&&option.price/option.count<selected.price/selected.count).sort((a,b)=>a.count-b.count)[0]||null;

    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-search-typing"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pg-search-typing'))customElements.define('pg-search-typing',class extends HTMLElement{
 connectedCallback(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  let list;try{list=JSON.parse(this.dataset.phrases||'[]')}catch(e){list=[]}
  if(list.length<2)return;
  const out=this.querySelector('.pg-st-text');if(!out)return;
  let i=0,n=out.textContent.length,mode='hold',timer=0,visible=false;
  const rand=(a,b)=>a+Math.random()*(b-a);
  const step=()=>{
   clearTimeout(timer);
   if(!visible||document.hidden)return;
   const text=list[i];
   if(mode==='type'){
    n++;out.textContent=text.slice(0,n);
    if(n>=text.length){mode='hold';timer=setTimeout(step,1600);}else timer=setTimeout(step,rand(55,80)+(/[ ,]/.test(text[n-1])?25:0));
   }else if(mode==='hold'){mode='erase';timer=setTimeout(step,0);}
   else if(mode==='erase'){
    n--;out.textContent=text.slice(0,Math.max(n,0));
    if(n<=0){i=(i+1)%list.length;mode='type';timer=setTimeout(step,380);}else timer=setTimeout(step,25);
   }
  };
  this.io=new IntersectionObserver(e=>{visible=e[0].isIntersecting;this.classList.toggle('is-on',visible);if(visible){clearTimeout(timer);timer=setTimeout(step,mode==='hold'?1600:200);}else clearTimeout(timer);},{threshold:.2});
  this.io.observe(this);
  this.vis=()=>{if(!document.hidden&&visible){clearTimeout(timer);timer=setTimeout(step,300);}else clearTimeout(timer);};
  document.addEventListener('visibilitychange',this.vis);
 }
 disconnectedCallback(){this.io&&this.io.disconnect();document.removeEventListener('visibilitychange',this.vis);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-specialties"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-specialty-carousel')) customElements.define('pg-specialty-carousel', class extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.pg-specialty-grid');
    this.querySelectorAll('[data-dir]').forEach((button) => button.addEventListener('click', () => {
      track.scrollBy({ left: Number(button.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
    }));
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pg-svc-sheet"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Carrega o site de exemplo nos mockups depois do load da página e ajusta a escala ao tamanho do mockup. */
  function fit(el, frame) {
    var base = +el.getAttribute('data-pg-live') || 1280;
    var scale = el.clientWidth / base;
    if (!scale) return;
    frame.style.width = base + 'px';
    frame.style.height = Math.ceil(el.clientHeight / scale) + 'px';
    frame.style.transform = 'scale(' + scale + ')';
  }
  function start(el, frame) {
    fit(el, frame);
    if (window.ResizeObserver) new ResizeObserver(function () { fit(el, frame); }).observe(el);
    frame.addEventListener('load', function () { el.classList.add('is-live'); });
    frame.setAttribute('src', frame.getAttribute('data-src'));
    /* Sites pesados demoram a disparar o load: revela o que já chegou após 5 s, sem deixar a moldura vazia */
    setTimeout(function () { el.classList.add('is-live'); }, 5000);
  }
  function boot() {
    var io = null;
    document.querySelectorAll('[data-pg-live]').forEach(function (el) {
      var frame = el.querySelector('iframe[data-src]');
      if (!frame || frame.getAttribute('src')) return;
      /* Exemplos abaixo da dobra só carregam quando chegam perto da tela */
      if (el.hasAttribute('data-pg-lazy') && 'IntersectionObserver' in window) {
        io = io || new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); var f = e.target.querySelector('iframe[data-src]'); if (f && !f.getAttribute('src')) start(e.target, f); });
        }, { rootMargin: '600px 0px' });
        io.observe(el);
        return;
      }
      start(el, frame);
    });
  }
  if (document.readyState === 'complete') boot(); else window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);

  /* Folha inferior (estilo iOS) para ver o site de exemplo sem sair da página, em telas de toque.
     Arraste para baixo, toque fora, use o X ou Esc para fechar. */
  var sheet, panel, frame, title, openLink, closeBtn, lastFocus, dragY = 0, startY = 0, startT = 0, dragging = false;
  var touchMode = window.matchMedia('(hover: none), (max-width: 767px)');
  function build() {
    sheet = document.createElement('div');
    sheet.className = 'pg-bsheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="pg-bsheet__backdrop" data-sheet-close></div>' +
      '<div class="pg-bsheet__panel" role="dialog" aria-modal="true" aria-labelledby="pg-bsheet-title">' +
      '<div class="pg-bsheet__head"><span class="pg-bsheet__grab" aria-hidden="true"></span>' +
      '<div class="pg-bsheet__bar"><b id="pg-bsheet-title"></b><a class="pg-bsheet__out" target="_blank" rel="noopener">Abrir em nova aba</a>' +
      '<button type="button" class="pg-bsheet__close" data-sheet-close aria-label="Fechar">&times;</button></div></div>' +
      '<iframe class="pg-bsheet__frame" referrerpolicy="no-referrer"></iframe></div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.pg-bsheet__panel');
    frame = sheet.querySelector('iframe');
    title = sheet.querySelector('#pg-bsheet-title');
    openLink = sheet.querySelector('.pg-bsheet__out');
    closeBtn = sheet.querySelector('.pg-bsheet__close');
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sheet-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) close(); });
    var head = sheet.querySelector('.pg-bsheet__head');
    head.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a,button')) return;
      dragging = true; startY = e.clientY; startT = Date.now(); dragY = 0;
      panel.style.transition = 'none';
      head.setPointerCapture(e.pointerId);
    });
    head.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dragY = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dragY + 'px)';
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = '';
      var fast = dragY / Math.max(1, Date.now() - startT) > 0.6;
      if (dragY > panel.offsetHeight * 0.25 || (fast && dragY > 40)) close();
      else panel.style.transform = '';
    }
    head.addEventListener('pointerup', end);
    head.addEventListener('pointercancel', end);
  }
  function open(url, host) {
    if (!sheet) build();
    lastFocus = document.activeElement;
    title.textContent = host || url.replace(/^https?:\/\//, '').split('/')[0];
    openLink.href = url;
    if (frame.getAttribute('src') !== url) frame.setAttribute('src', url);
    frame.title = 'Site de exemplo: ' + title.textContent;
    sheet.hidden = false;
    document.documentElement.classList.add('pg-bsheet-open');
    panel.style.transform = '';
    requestAnimationFrame(function () { sheet.classList.add('is-open'); closeBtn.focus({ preventScroll: true }); });
  }
  function close() {
    sheet.classList.remove('is-open');
    panel.style.transform = '';
    document.documentElement.classList.remove('pg-bsheet-open');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pg-sheet]');
    if (!link || !touchMode.matches) return;
    e.preventDefault();
    open(link.href, link.getAttribute('data-pg-sheet'));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
